// extracted by mini-css-extract-plugin
export default {"ButtonBase":"ButtonBase_ButtonBase__BXfhz"};